import { useQuery } from '@tanstack/react-query';
import {Organization, organizationsService} from "@/services/apiOrganization";

export const useOrganization = () => {
  return useQuery<Organization, Error>({
    queryKey: ['organization', 'current'],
    queryFn: organizationsService.getCurrent,
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 7 * 24 * 60 * 60 * 1000,
  });
};